import {
  QUERY_URL_PARAM,
  RESULT_PAGE_URL_PARAM,
  RESULT_TYPE_URL_PARAM,
  SORT_URL_PARAM,
} from "@/components/Search/constants";
import { getFacetAttributeName } from "@/components/Search/utils/getFacetAttributeName";

export function getFacetFiltersValue({
  indexName,
  paramsArray,
}: {
  indexName: string;
  paramsArray: Array<[string, string]>;
}): Array<string | string[]> {
  let output: Array<string | string[]> = [];
  let facetValues: Record<string, string[]> = {};

  for (const [paramName, paramValue] of paramsArray) {
    if (paramName === QUERY_URL_PARAM) continue;
    if (paramName === RESULT_PAGE_URL_PARAM) continue;
    if (paramName === RESULT_TYPE_URL_PARAM) continue;
    if (paramName === SORT_URL_PARAM) continue;
    const indexFacetName = getFacetAttributeName(paramName, { indexName });
    const filter = `${indexFacetName}:${paramValue}`;

    if (facetValues[indexFacetName] === undefined) {
      facetValues[indexFacetName] = [filter];
    } else {
      facetValues[indexFacetName].push(filter);
    }
  }

  Object.keys(facetValues).forEach((facet) => {
    if (facetValues[facet].length === 1) {
      output.push(facetValues[facet][0]);
    } else {
      output.push(facetValues[facet]);
    }
  });

  return output;
}
